import { UOM_TYPE_DATA } from '../actions/actionType'

const initialState = {
  uomTypes: [],
}
export default function UomReducer(state = initialState, action) {
  switch (action.type) {
    case UOM_TYPE_DATA:
      return { ...state, uomTypes: action.payload }
    default:
      return state
  }
}
